import React, {useEffect, useMemo, useState} from 'react';
import {IContentIdResponse} from '@/lib/types/common-types';
import BaseObjectMetadata from './BaseObjectMetadata';
import ExpandableRecords from '@/components/ExpandableRecords';
import ActivityIndicator from '@/components/ui/activity-indicator'

function ContentRecord({
                           record,
                           isOpen = false,
                           mode = "record",
                           showParentRecord = true
                       }: {
    record: IContentIdResponse;
    isOpen: boolean;
    mode?: string,
    showParentRecord?: boolean;
}) {

    let [isLoading, setIsLoading] = React.useState(false);
    let [data, setData] = React.useState(null);
    let [Seasons, setSeasons] = React.useState(null);
    let [Episodes, setEpisodes] = React.useState(null);
    let [Edits, setEdits] = React.useState(null);
    let [Clips, setClips] = React.useState(null);
    let [Parent, setParent] = React.useState(null);
    let [baseRecord, setBaseRecord] = React.useState(null);
    let [hasFullRecord, setHasFullRecord] = useState(mode === "record");

    /**
     * When the response changes (ie the record from the parent)
     */
    useEffect(() => {
        setData(record)
    }, [record]);

    useEffect(() => {
        if (data) {
            let {Seasons, Episodes, Edits, Clips, Parent, ...baseRecord} = data;
            if (Seasons) {
                //console.log('Seasons', Seasons);
                setSeasons(Seasons);
            }
            if (Episodes) {
                setEpisodes(Episodes);
            }
            if (Edits) {
                setEdits(Edits);
            }
            if (Clips) {
                setClips(Clips);
            }
            if (Parent && showParentRecord) {
                setParent(Parent);
            }
            if (baseRecord) {
                setBaseRecord(baseRecord);
            }
        }

    }, [data]);

    /**
     * If an entered value matches the registry search, we know ther results returned
     * are either valid or invalid. As such, we'll redirect the the record view on success
     * @param id
     * @param registry
     */
    const resolve = async (id, registry) => {
        if (isLoading) return;
        setIsLoading(true);
        let url = `/api/resolve/json/${id}`;
        let response = fetch(url);
        try {
            const res = await response;
            let data = await res.json();
            setData(data.response);

        } catch (e) {
        }
        setHasFullRecord(true);
        setIsLoading(false);
    };

    const onRecordOpen = async (isOpen) => {
        console.log('onRecordOpen', isOpen);
        if (mode === "card") {
            if (!hasFullRecord && isOpen) {
                await resolve(data.ID, "content");
            } else if (hasFullRecord && !isOpen) {
                setData(record);
            }
        }
    }

    return (
        <div className="md:p-4 p-2">

            {baseRecord ? <BaseObjectMetadata
                record={baseRecord}
                hasFullRecord={hasFullRecord}
                defaultOpen={isOpen}
                mode={mode}
                isLoading={isLoading}
                onOpen={onRecordOpen}/> : null}

            {Parent && (<ExpandableRecords
                title="Parent"
                data={[Parent]} // Empty data
                canClose
                defaultOpen={false}
            />)}

            {(Episodes && Episodes.length > 0) && (<ExpandableRecords
                title="Episodes"
                data={Episodes} // Empty data
                canClose
                defaultOpen={false}
            />)}

            {(Edits && Edits.length > 0) && (<ExpandableRecords
                title={"Edits & Clips"}
                data={Edits} // Empty data
                canClose
                defaultOpen={false}
            />)}

            {(Clips && Clips.length > 0) && (<ExpandableRecords
                title={"Clips"}
                data={Clips} // Empty data
                canClose
                defaultOpen={false}
            />)}

            {(Seasons && Seasons.length > 0) && (<ExpandableRecords
                title={Episodes ? "More Seasons" : "Seasons"}
                data={Seasons} // Empty data
                canClose
                defaultOpen={false}
            />)}


        </div>
    )
}

/**
 *  <div className="flex justify-center items-center">
 *                 <ActivityIndicator size={40} hidden={!isLoading}/>
 *             </div>
 */

export default ContentRecord;
